
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("gPkRD", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-US.9d88c8d7.js.map
